import React from 'react';
import { Button } from '@material-ui/core';
import { useAppSelector } from 'index';
import i18n from 'i18n-js';
import logo from 'assets/Img-Welcome.svg';
import { useStyles } from '../styles';

export default function ContactJamesTeam() {
    const classes = useStyles();
    const restaurant = useAppSelector((state) => state.restaurantDetails.restaurantInformation);
    const user = useAppSelector((state) => state.user);
    const emailTemplate = `info@gastrojames.ch?subject=${i18n.t(
        'restaurant.reservationModule'
    )} - ${restaurant?.name}&body=${i18n.t('restaurant.reservationModuleEmailBody', {
        restaurantName: restaurant?.name,
        userName: user?.profile?.firstName + ' ' + user?.profile?.lastName,
        userEmail: user?.profile?.email,
    })},`;

    return (
        <div className={classes.contactJamesTeamContainer}>
            <img src={logo} alt="logo" />
            <h1>{i18n.t('restaurant.reservationsNotActive')}</h1>
            <h3>{i18n.t('restaurant.reservationsDescription')}</h3>
            <Button
                component="a"
                variant="contained"
                color="primary"
                href={`mailto:${emailTemplate}`}
            >
                {i18n.t('button.contactJamesTeam')}
            </Button>
        </div>
    );
}
